/* import __COLOCATED_TEMPLATE__ from './icon-play.hbs'; */
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
export default SvgIcon.extend({
  classNames: ['svg-icon--play'],
  width: 32,
  height: 32,
  viewBox: '0 0 32 32'
});